import type { TUserJobsReportListParams } from 'app/queries/reports/reportsKeys';

export const buildUserJobsReportRequest = (workspaceId: string, userId: string, params: TUserJobsReportListParams) => ({
  wsid: workspaceId,
  userId,
  pageNo: params.page.toString(),
  pageSize: params.pageSize.toString(),
  orderBy: 'createdAt',
  orderType: 'desc',
  search: '',
  jobsFrom: params.jobsFrom,
  jobsTo: params.jobsTo,
});
